import { Injectable } from '@angular/core';
import { AbstractMessageCommand } from 'flux-connection';
import { Command, CommandInterfaces } from 'flux-core';

@Injectable()
@Command()
export class GetPremiumShapeUsage extends AbstractMessageCommand {

    public static get implements(): Array<CommandInterfaces> {
        return [ 'IMessageCommand' ];
    }

    public execute(): boolean {
        return true;
    }
}

Object.defineProperty( GetPremiumShapeUsage, 'name', {
    value: 'GetPremiumShapeUsage',
});
